<template>
	<div class="passport content">
		<component :is="href('/interactions/passport/details').content" />
		<div v-if="passport && passport.brief">
			<whitebox-passport :passport="passport"/>
			<div class="actions">
				<button @click="forget">{{ href('/interactions/passport/details').meta.forget }}</button>
			</div>
		</div>
		<div v-else>
			<h3><font-awesome-icon icon="id-card"/> {{ href('/interactions/passport/details').meta.profile }}</h3>
			<div class="profile">{{ href('/interactions/passport/details').meta.unknown }}</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import hreflang from '@/lib/hreflang'

export default {
	name: 'PassportsInteraction',
	mixins: [ hreflang ],
	data() {
		return {
		}
	},
	methods: {
		...mapActions('demo', ['forget'])
	},
	computed: {
		...mapState({
			passport: state => state.demo.passport,
		}),
	},
	created() {
		this.document(require('documents/en/interactions/passport-details.md'), 'en')
	}
}
</script>

<style scoped lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/mixins.less');

h3 {
	font-size: @font-size-s;
	margin-top: @gap * 2;
	color: @gray-50;
	font-weight: @normal;
	margin-bottom: 0;
}

.profile {
	.count();
}

.actions {
	margin-top: @gap * 2;
}
.content {
	padding: 0;
}

</style>
